(ns ui.components.radix-ui.tooltip.view
  (:require
   [ui.util :as uu]
   [react :as react]
   [oops.core :as oops]
   ["@radix-ui/react-tooltip" :as Tooltip]
   [reagent.core :as r]))

(defn adapt
  ([cls-name]
   (r/adapt-react-class (oops/oget+ Tooltip cls-name)))
  ([parent-cls cls-name]
   (r/adapt-react-class (oops/oget+ (oops/oget+ Tooltip parent-cls) cls-name))))


(def tooltip-provider (adapt "Provider"))
(def tooltip-root (adapt "Root"))
(def tooltip-trigger (adapt "Trigger"))
(def tooltip-portal (adapt "Portal"))
(def tooltip-content (adapt "Content"))
(def tooltip-arrow (adapt "Arrow"))


(def default-props
  {:align          :center
   :delay-duration 500
   :side           :top
   :side-offset    5})

(def tooltip-z-index 30000010)

(defn forward-ref
  [props-render-fn]
  (react/forwardRef
   (fn [props ref]
     (r/as-element
      (props-render-fn (assoc (js->clj props :keywordize-keys true)
                              :ref ref))))))

(defn view
  ([trigger-element content-element]
   [view default-props trigger-element content-element])
  ([props trigger-element content-element]
   (let [{:keys [align as-child? delay-duration side side-offset
                 trigger-class content-class]} (merge default-props props)]
     [tooltip-provider
      [tooltip-root
       {:delayDuration delay-duration}
       (if as-child?
         [tooltip-trigger
          {:asChild true
           :class   "m-0 p-0"}
          [:>
           trigger-element]]
         [tooltip-trigger
          {:class (uu/cm "m-0 p-0" trigger-class)}
          trigger-element])
       [tooltip-portal
        {:style {:z-index tooltip-z-index}}
        (when-not (:disabled? props)
          [tooltip-content
           {:class      (uu/cm
                         "p-3 text-sm m-0 max-w-64"
                         "bg-secondary-gloomy text-secondary-gloomy-text rounded"
                         content-class)
            :sideOffset side-offset
            :align      align
            :side       side
            :style      {:z-index tooltip-z-index}}
           content-element
           [tooltip-arrow
            {:class "fill-secondary-gloomy"}]])]]])))

(defn as-child
  [props render-trigger-fn content-element]
  (let [{:keys [align delay-duration side]} (merge default-props props)]
    [tooltip-provider
     [tooltip-root
      {:delayDuration delay-duration}
      [tooltip-trigger
       {:asChild true
        :class   "m-0 p-0"}
       [:>
        (forward-ref render-trigger-fn)]]
      [tooltip-portal
       {:style {:z-index tooltip-z-index}}
       (when-not (:disabled? props)
         [tooltip-content
          {:class      (uu/cm "py-2 px-3 text-sm m-0 max-w-64 bg-secondary-gloomy text-secondary-gloomy-text border border-solid border-gloomy-regular-border-paler rounded")
           :sideOffset 5
           :align      align
           :side       side
           :style      {:z-index tooltip-z-index}}
          content-element
          [tooltip-arrow
           {:class "fill-secondary-gloomy"}]])]]]))
